import React, { Fragment, useState, useEffect } from "react";
import Breadcrumb from "../../../components/common/breadcrumb";
import { useSelector, useDispatch } from "react-redux";
import NumberFormat from "react-number-format";
import { Link } from "react-router-dom";
import Time from "react-time-format";
import { change_Lang } from "../../../actions/Helper_action";
import { Search } from "react-feather";
import {
  Get_List_Paradan,
  Paradan_Delete_Status,
  View_Paradan_Bill,
} from "../../../actions_agent/Invoice_action";
import { Button, Input, Modal, Select, Tooltip, Tabs, Switch } from "antd";
import View_Paradan from "./View_Paradan";
import Swal from "sweetalert2";
import { isMobile } from "react-device-detect";
import CustomDataTable from "../../../components/HOC/CustomDataTable";
import { FaBan, FaBars, FaEye, FaPrint } from "react-icons/fa";
const ListParadan = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.AuthReducer.user);
  const [hideDirector, setHideDirector] = useState(false);
  useEffect(() => {
    if (user && user.v_bill !== false) {
      setHideDirector(false);
    } else {
      setHideDirector(true);
    }
    dispatch(Get_List_Paradan());
  }, []);
  const lang = useSelector((state) => state.HelperReducer.lang);
  const paradan_lists = useSelector(
    (state) => state.Invoice_Reducer.paradan_lists
  );
  const [search, setsearch] = useState("");
  const [select_property, setselect_property] = useState("");
  const [isModalVisible, setisModalVisible] = useState(false);
  const showModal = () => {
    setisModalVisible(true);
  };
  const handleCancel = () => {
    setisModalVisible(false);
  };
  const onChangeSearch = (e) => {
    setsearch(e.target.value);
    setselect_property("");
  };
  const handleChange_Property = (value) => {
    setselect_property(value);
  };
  const onDelete_Paradan = (id) => {
    return Swal.fire({
      title: dispatch(change_Lang("Are you sure")),
      text: dispatch(change_Lang("You won't be able to delete this!")),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: dispatch(change_Lang("Yes, delete it")),
      cancelButtonText: dispatch(change_Lang("cancel")),
      confirmButtonClass: "fk",
      cancelButtonClass: "fk",
      customClass: {
        title: "fk",
        content: "fk",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(Paradan_Delete_Status(id));
        Swal.fire({
          title: dispatch(change_Lang("Delete")),
          text: dispatch(
            change_Lang("Your work has been successfully completed")
          ),
          timer: 1000,
          icon: "success",
          customClass: {
            title: "fk",
            content: "fk",
          },
        });
      }
    });
  };
  const Paradan_getPrint = () => {
    window.setTimeout("window.print()", 4000);
  };
  const [showModal_, setShowModal] = useState(false);
  const toggleModal = () => {
    setShowModal(!showModal_);
  };
  const initialColumns = React.useMemo(() => {
    return [
      {
        name: dispatch(change_Lang("id")),
        selector: "id",
        center: true,
        compact: true,
        width: "100px",
        visibility: true,
      },
      {
        name: dispatch(change_Lang("Property Detail")),
        selector: "property_detail",
        center: true,
        compact: true,
        width: "200px",
        visibility: true,
      },
      {
        name: dispatch(change_Lang("It was given to sir")),
        selector: "payer",
        center: true,
        compact: true,
        width: "200px",
        visibility: true,
      },
      {
        name: dispatch(change_Lang("received from Mr")),
        selector: "reciver",
        center: true,
        compact: true,
        width: "200px",
        visibility: true,
      },
      {
        name: dispatch(change_Lang("type")),
        selector: "type",
        center: true,
        compact: true,
        width: "130px",
        visibility: true,
      },
      {
        name: dispatch(change_Lang("tr_amount")),
        selector: "Amount",
        center: true,
        compact: true,
        width: "120px",
        visibility: true,
      },
      {
        name: dispatch(change_Lang("date")),
        selector: "date",
        center: true,
        compact: true,
        width: "110px",
        visibility: true,
      },
      {
        name: dispatch(change_Lang("Action")),
        selector: "action",
        center: true,
        compact: true,
        omit: hideDirector,
        width: "120px",
        visibility: true,
      },
    ];
  }, [hideDirector]);
  const [columns, setColumns] = useState(initialColumns);
  const handleColumnToggle = (columnKey) => {
    setColumns((prevColumns) =>
      prevColumns.map((column) =>
        column.selector === columnKey
          ? { ...column, visibility: !column.visibility }
          : column
      )
    );
  };
  const datas = paradan_lists
    .filter((data) => {
      if (data.status !== "delete") {
        if (isNaN(search)) {
          if (
            data.payer &&
            data.payer.toLowerCase().startsWith(search.toLowerCase())
          ) {
            return (
              data.payer &&
              data.payer.toLowerCase().startsWith(search.toLowerCase())
            );
          } else if (
            data.num &&
            data.num.toLowerCase().startsWith(search.toLowerCase())
          ) {
            return (
              data.num &&
              data.num.toLowerCase().startsWith(search.toLowerCase())
            );
          }
        } else if (select_property === "Monthly rent invoice") {
          return data.type === "Monthly rent invoice";
        } else if (select_property === "Service Bill") {
          return data.type === "Service Bill";
        } else if (select_property === "Insurance Bill") {
          return data.type === "Insurance Bill";
        } else if (select_property === "Sell") {
          return data.type === "Sell";
        } else if (select_property === "Arabun") {
          return data.type === "Arabun";
        } else if (select_property === "investor") {
          return data.type === "investor";
        } else if (select_property === "Buy") {
          return data.type === "Buy";
        } else {
          if (data.Amount && data.Amount.toString().startsWith(search)) {
            return data.Amount && data.Amount.toString().startsWith(search);
          } else if (data.num && data.num.toString().startsWith(search)) {
            return data.num && data.num.toString().startsWith(search);
          } else {
            return (
              data.invoice_No && data.invoice_No.toString().startsWith(search)
            );
          }
        }
      }
    })
    .map((el, i) => {
      return {
        id: el.invoice_No,
        payer: (
          <span
            className={`${lang === "en" ? "" : "fk"}`}
            style={{ fontSize: "15px" }}
          >
            {el.payer}
          </span>
        ),
        reciver: (
          <span
            className={`${lang === "en" ? "" : "fk"}`}
            style={{ fontSize: "15px" }}
          >
            {el.reciver}
          </span>
        ),
        type: (
          <span
            className={`${lang === "en" ? "font-weight-bold" : "fk"}`}
            style={{
              fontWeight: "bolder",
              color: `${
                el.type === "Monthly rent invoice"
                  ? "#4064d7"
                  : el.type === "Service Bill"
                  ? "#4064d7"
                  : "#4064d7"
              }`,
              fontSize: "15px",
            }}
          >
            {dispatch(change_Lang(el.type))}
          </span>
        ),
        Amount: (
          <span style={{ fontSize: "15px" }}>
            <NumberFormat
              displayType="text"
              thousandSeparator={true}
              value={el.Amount}
              className={`${lang === "en" ? "" : "fk"}`}
            />
            &nbsp;{dispatch(change_Lang(el.currency))}
          </span>
        ),
        status:
          el.status === "active" ? (
            <label style={{ color: "green" }}>{el.status}</label>
          ) : el.status === "Peending" ? (
            <label style={{ color: "red" }}>{el.status}</label>
          ) : (
            ""
          ),
        date: (
          <Time
            value={el.createdAt}
            format="YYYY-MM-DD"
            style={{ color: "black" }}
            className={`${lang === "en" ? "" : "fk"}`}
          />
        ),
        property_detail: (
          <>
            <span
              className={`${lang === "en" ? "" : "fk"}`}
              style={{ fontSize: "15px" }}
            >
              {el.property && dispatch(change_Lang(el.property))}
            </span>
            &nbsp;-&nbsp;
            <span
              className={`${lang === "en" ? "" : "fk"}`}
              style={{ fontSize: "15px" }}
            >
              {el.place && el.place}
            </span>
            &nbsp;-&nbsp;
            <span
              className={`${lang === "en" ? "" : "fk"}`}
              style={{ fontSize: "15px" }}
            >
              {el.num}
            </span>
          </>
        ),
        action: (
          <>
            <Tooltip title="View">
              <Button
                style={{ background: "#efefed", color: "#4064d7" }}
                shape="circle"
                onClick={() => {
                  dispatch(View_Paradan_Bill(el._id, el.invoice_No));
                  showModal();
                }}
                icon={
                  <FaEye
                    style={{
                      cursor: "pointer",
                    }}
                    className="text-center mt-1"
                  />
                }
              />
            </Tooltip>
            &nbsp;
            <Tooltip title="Print">
              <Link to={`/View_paradan_print/${el._id}/${el.invoice_No}`}>
                <Button
                  style={{ background: "#efefed", color: "#4064d7" }}
                  shape="circle"
                  onClick={() => {
                    dispatch(View_Paradan_Bill(el._id, el.invoice_No));
                    Paradan_getPrint();
                  }}
                  icon={
                    <FaPrint
                      style={{
                        cursor: "pointer",
                      }}
                      className="text-center mt-1"
                    />
                  }
                />
              </Link>
            </Tooltip>
            &nbsp;
            {user.d_bill !== false ? (
              <Tooltip title="Delete">
                <Button
                  style={{ background: "#efefed", color: "#4064d7" }}
                  shape="circle"
                  onClick={() => onDelete_Paradan(el._id)}
                  icon={
                    <FaBan
                      style={{
                        cursor: "pointer",
                      }}
                      className="text-center mt-1"
                    />
                  }
                />
              </Tooltip>
            ) : (
              ""
            )}
          </>
        ),
      };
    });
  const { Option } = Select;
  return (
    <>
      <Fragment>
        <Breadcrumb
          title={dispatch(change_Lang("Payments List"))}
          parent={dispatch(change_Lang("taking money"))}
        />
        <div
          className={`${
            lang === "en" ? "container-fluid" : "container-fluid fk"
          }`}
        >
          <div className="row">
            <div className="col-xs-12 col-sm-12 ">
              <div
                className={
                  isMobile
                    ? "d-none"
                    : "fk col-md-12 d-flex justify-content-center"
                }
              >
                <Tabs defaultActiveKey="3" animated={false}>
                  <Tabs.TabPane
                    tab={
                      <Link className="exp_color" to={"/take_money_list"}>
                        {dispatch(change_Lang("list taking money"))}
                      </Link>
                    }
                    key="1"
                  ></Tabs.TabPane>
                  <Tabs.TabPane tab="" key=""></Tabs.TabPane>
                  <Tabs.TabPane tab="" key=""></Tabs.TabPane>
                  <Tabs.TabPane
                    tab={
                      <Link className="exp_color" to={"/list_of_Masrufat"}>
                        {dispatch(change_Lang("Expenses List"))}
                      </Link>
                    }
                    key="2"
                  ></Tabs.TabPane>
                  <Tabs.TabPane tab="" key=""></Tabs.TabPane>
                  <Tabs.TabPane
                    className="fk"
                    tab={
                      <Link className="" to={"/List_Paradan"}>
                        {dispatch(change_Lang("Payments List"))}
                      </Link>
                    }
                    key="3"
                  ></Tabs.TabPane>
                </Tabs>
              </div>
              <div className={isMobile ? "" : "card"}>
                <div className="row ">
                  <div
                    className={
                      isMobile
                        ? "col-md-4 d-flex justify-content-center"
                        : "col-md-3 card-header d-flex justify-content-start"
                    }
                  >
                    <Select
                      onChange={handleChange_Property}
                      value={select_property}
                      defaultValue={dispatch(change_Lang("Choose"))}
                      className="fk col-12 text-center"
                      size="middle"
                      showSearch
                      optionFilterProp="children"
                      filterOption={true}
                      showArrow={false}
                      style={{
                        fontSize: "16px",
                        borderBottomColor: "#052f43",
                      }}
                    >
                      <Option className="fk" value={""}>
                        {dispatch(change_Lang("Choose"))}
                      </Option>
                      <Option className="fk" value="Monthly rent invoice">
                        {dispatch(change_Lang("Monthly rent invoice"))}
                      </Option>
                      <Option className="fk" value="Service Bill">
                        {dispatch(change_Lang("Service Bill"))}
                      </Option>
                      <Option className="fk" value="Insurance Bill">
                        {" "}
                        {dispatch(change_Lang("Insurance Bill"))}
                      </Option>
                      <Option className="fk" value="Sell">
                        {" "}
                        {dispatch(change_Lang("Sell"))}
                      </Option>
                      <Option className="fk" value="Buy">
                        {" "}
                        {dispatch(change_Lang("Buy"))}
                      </Option>
                      <Option className="fk" value="Arabun">
                        {" "}
                        {dispatch(change_Lang("Arabun"))}
                      </Option>
                      <Option className="fk" value="investor">
                        {" "}
                        {dispatch(change_Lang("investor"))}
                      </Option>
                    </Select>
                  </div>
                  <div
                    className={isMobile ? "col-md-6" : "col-md-6 card-header"}
                  >
                    <div className=" text-center mt-2">
                      <h3 style={{ fontWeight: "bold", color: "#4064d7" }}>
                        {dispatch(change_Lang("Payments List"))}
                      </h3>
                    </div>
                  </div>
                  <div
                    className={
                      isMobile
                        ? "col-md-3 d-flex justify-content-center form-inline"
                        : "col-md-3 d-flex justify-content-start form-inline"
                    }
                  >
                    <Input
                      type="text"
                      name="search"
                      value={search}
                      onChange={(e) => setsearch(e.target.value)}
                      size="middle"
                      placeholder={dispatch(change_Lang("Search"))}
                      autoComplete="off"
                      style={{ width: "180px" }}
                      prefix={<Search color="lightgray" />}
                    />
                    &nbsp;&nbsp;
                    <span className="">
                      <button
                        onClick={toggleModal}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                        className="btn  btn-sm px-1 py-2 exp_btn "
                      >
                        <FaBars />
                      </button>
                    </span>
                  </div>
                </div>
                <div className="row table-responsive">
                  <CustomDataTable
                    columns={columns.filter((column) => column.visibility)}
                    data={datas}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal
          title="Select Columns"
          open={showModal_}
          onCancel={toggleModal}
          width={390}
          footer={[
            <Button key="close" onClick={toggleModal}>
              Close
            </Button>,
          ]}
        >
          {columns.map((column) => (
            <div
              className="row d-flex justify-content-center"
              key={column.selector}
              style={{ marginBottom: 16, textAlign: "justify" }}
            >
              <span
                className="col-5 fk"
                style={{ marginLeft: 8, fontSize: "15px" }}
              >
                {column.name}
              </span>
              <Switch
                checked={column.visibility}
                style={{
                  background: column.visibility ? "#5172dd" : "#babbba",
                }}
                className="col-1"
                onChange={() => handleColumnToggle(column.selector)}
              />
            </div>
          ))}
        </Modal>
        <Modal
          title={dispatch(change_Lang("Payment bills"))}
          footer={false}
          className="fk"
          width={1200}
          open={isModalVisible}
          onOk={handleCancel}
          onCancel={handleCancel}
          bodyStyle={{ background: "#f6f8fa" }}
        >
          <View_Paradan handleCancel={handleCancel} />
        </Modal>
      </Fragment>
    </>
  );
};

export default ListParadan;
